<div class="qp-dialog">
    <header class="qp-dialog__header">
        <div class="qp-dialog__header-text">
            <h2 class="qp-dialog__title">Student Well Being Report</h2>
            <h6 class="qp-dialog__meta" *ngIf="data.studentName">Student Name: {{ data.studentName }}</h6>
            <h6 class="qp-dialog__meta">Adm No: {{ data.admNo }}</h6>
            <!-- <h6 class="qp-dialog__meta" *ngIf="data.feedBackDate">FeedBack Date: {{ data.feedBackDate }}</h6>
            <h6 class="qp-dialog__meta" *ngIf="data.sectionName">Section Name: {{ data.sectionName }}</h6> -->
        </div>
        <div class="qp-dialog__header-actions">
            <button type="button" class="qp-dialog__pdf-btn" (click)="downloadPdf()" aria-label="Download PDF">
               Download PDF <img src="assets/image/pdficon.svg" alt="" />
            </button>
            <button type="button" class="qp-dialog__close" (click)="close()" aria-label="Close dialog">
                <i class="fa-solid fa-xmark" aria-hidden="true"></i>
            </button>
        </div>
    </header>

    <div class="qp-dialog__body">
        <p *ngIf="loading" class="qp-dialog__status">Loading questions...</p>
        <p *ngIf="!loading && loadError" class="qp-dialog__status qp-dialog__status--error">{{ loadError }}</p>
        <p *ngIf="!loading && !loadError && !questions.length" class="qp-dialog__status">No questions found.</p>

        <article *ngFor="let question of questions; let qi = index" class="qp-dialog__question-block">
            <p class="qp-dialog__question">
                Q{{ qi + 1 }}. {{ getQuestionText(question) }}
            </p>

            <div *ngFor="let opt of getSortedOptions(question); let oi = index" class="qp-dialog__option"
                [class.qp-dialog__option--selected]="isOptionSelected(question.questionId, opt)">
                <span class="qp-dialog__option-text">
                    {{ oi + 1 }}. {{ getOptionLabel(question.questionId, opt) }}
                    <i *ngIf="isOptionSelected(question.questionId, opt)"
                        class="fa-solid fa-check qp-dialog__check" aria-hidden="true"></i>
                </span>
            </div>
        </article>
    </div>
</div>
